export default __webpack_public_path__ + "static/media/clickSubscriptionIcon.24d62394.svg";